import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const getUnitWorkloadTeachingHours = (unitWorkloadId: number, campusId: number) => {
  return trpc.trd.getUnitWorkloadTeachingHours.useQuery(
    { unitWorkloadId, campusId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!unitWorkloadId,
    },
  );
};

export const getUnitWorkloadAcademicTeachings = (unitWorkloadId: number, campusId: number) => {
  return trpc.trd.getAcademicDutyHours.useQuery(
    { unitWorkloadId, campusId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!unitWorkloadId,
    },
  );
};
